import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import { createTableHeaderCell } from "@whalecloud/page-builder-core/utils/elementUtils";
import Table from "./components/Table";
import TableSettings from "./components/TableSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/table_setting.svg";
import { getLocale, defaultTarget, defaultDataSource, defaultColumns } from '@utils/util';

const tarnsformDefaultColumns = defaultColumns.map(item => {
  return {
    columnSettings: {
      ...item
    }
  }
});

const getElements = () => {
  const elements = [];
  tarnsformDefaultColumns.forEach(item => {
    elements.push(createTableHeaderCell({ data: item }));
  });
  return elements;
}

export default () => {
  const messages = getLocale();
  return {
    name: 'table',
    group: ElementGroup.COMPLEX,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_TABLE'],
    toolBarPreview: <PluginSvg />,
    data: {
      tableSettings: {
        rowKey: 'key',
        size: 'default',
        bordered: false,
        rowSelection: false,
        pagination: false,
        dataSource: defaultDataSource,
        autoInitialize: true,
        checked: [], // 记录选中的表格
        hideLabel: false,
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_TABLE']
      },
      settings: {
        margin: {
          mobile: { all: 0 },
          desktop: { all: 0 },
          advanced: true
        },
        padding: {
          mobile: { top: 15, left: 15, right: 15, bottom: 15 },
          desktop: { top: 0, left: 25, right: 25, bottom: 0 },
        },
        width: {
          value: "100%"
        },
      }
    },
    elements: getElements,
    pluginComponent: Table, // 插件渲染组件
    pluginSettingComponent: TableSettings, // 插件设置项组件
  }
}
